export const parseResponse = async (response: Response, errorCb?: (msg: string) => void) => {
  const header = response.headers.get('Content-Type');
  if (header && header.includes('application/json')) {
    try {
      return await response.json();
    } catch (error) {
      if (errorCb) errorCb(`Failed to parse response body: ${response.url}, ${error}`);
    }
  }
  return null;
};
